import { render, staticRenderFns } from "./FilterBadges.vue?vue&type=template&id=c43aa87e&scoped=true&"
import script from "./FilterBadges.vue?vue&type=script&lang=js&"
export * from "./FilterBadges.vue?vue&type=script&lang=js&"
import style0 from "./FilterBadges.vue?vue&type=style&index=0&id=c43aa87e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c43aa87e",
  null
  
)

export default component.exports